import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'Login',
        component: () => import("@/views/LoginView/LoginView")
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import("@/views/HomeView/index"),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/groupBuying',
        name: 'GroupBuying',
        component: () => import("@/views/groupBuying/index")
    },
    {
        path: '/miniApp',
        name: 'MiniApp',
        component: () => import("@/views/miniApp/index")
    },
    {
        path: '/pcJdApp',
        name: 'PcJdApp',
        component: () => import("@/views/pcJdApp/index")
    },
    {
        path: '/company',
        name: 'CompanyIndex',
        component: () => import("@/views/company/index")
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index.vue'),
        children: [
            {
                path: 'staff',
                name: 'StaffList',
                component: () => import('@/views/merchant/staff/list.vue')
            },
            {
                path: 'paymentList',
                name: 'PaymentList',
                component: () => import('@/views/merchant/payment/list.vue')
            },
            {
                path: 'trafficList',
                name: 'TrafficList',
                component: () => import('@/views/merchant/traffic/list.vue')
            }
        ]
    },
    {
        path: '/mini',
        name: 'mini',
        component: () => import('@/views/mini/index.vue'),
        children: [
            {
                path: '/mini/companyList',
                name: 'companyListMini',
                component: () => import('@/views/mini/company/list.vue')
            },
            {
                path: '/mini/templateList',
                name: 'templateListMini',
                component: () => import('@/views/mini/template/list.vue')
            },
            
            {
                path: '/mini/pageList',
                name: 'pageListMini',
                component: () => import('@/views/mini/template-page/list.vue')
            },
            {
                path: '/mini/moduleList',
                name: 'moduleListMini',
                component: () => import('@/views/mini/template-module/list.vue')
            },
        ]
    },
    {
        path: '/jd',
        name: 'jd', 
        component: () => import('@/views/jd/index.vue'),
        children: [
            {
                path: '/jd/companyList',
                name: 'companyListJd',
                component: () => import('@/views/jd/company/list.vue')
            },
            {
                path: '/jd/templateList',
                name: 'templateListJd',
                component: () => import('@/views/jd/template/list.vue')
            },
            
            {
                path: '/jd/pageList',
                name: 'pageListJd',
                component: () => import('@/views/jd/template-page/list.vue')
            },
            {
                path: '/jd/moduleList',
                name: 'moduleListJd',
                component: () => import('@/views/jd/template-module/list.vue')
            },
        ]
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

const whiteList = ['/']

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token')
    if (whiteList.includes(to.path)) {
        next()
        return
    }
    if (!token) {
        next('/')
        return
    }
    next()
})

export default router
